import './App.css';
import './styles/global.css';
import Navbar from './components/Home/Navbar';
import Footer from './components/Home/Footer';
import WhatsappDisplay from './components/Home/WhatsappDisplay';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import OurTeam from './pages/OurTeam';
import WorkWithUs from './pages/WorkWithUs';
import Disclaimer from './pages/Disclaimer';
import Probono from './pages/Probono';
import Blog from './pages/Blog';
import BlogPostPage from './pages/BlogPostPage';
import ShowroomCondo from './pages/ShowroomCondo';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PartnerWithUs from './pages/PartnerWithUs';
import TermsOfUse from './pages/TermsOfUse';
// import ShowroomHDB from './pages/ShowroomHDB';
import PartnerTestimonialFull from './components/Partnerwithus/PartnerTestimonialFull';

function App() {
  return (
    
    <div className="App">
      <Router>
        <Navbar />
          <div style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/our_team" element={<OurTeam />} />
              <Route path="/work_with_us" element={<WorkWithUs />} />
              <Route path="/privacy_policy" element={<PrivacyPolicy />} />
              <Route path="/pro-bono" element={<Probono />} />
              <Route path="/terms_of_use" element={<TermsOfUse />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path='/blog' element={<Blog />} />
              <Route path='/blog/:slug' element={<BlogPostPage />} />
              <Route path="/condominium" element={<ShowroomCondo />} />
              <Route path="/partnerwithus" element={<PartnerWithUs />} />
              {/* <Route path="/hdb" element={ShowroomHDB} /> */}
              <Route path="/partner-testimonials" element={<PartnerTestimonialFull />} />
            </Routes>
          </div>
        <WhatsappDisplay />
        <Footer />
      </Router>
    </div>

  );
}

export default App;